import plantImg from '../../../../shared/img/ppt/plant.png';
import womanImg from '../../../../shared/img/ppt/woman.png';

const addSlide2 = (pptx, schoolName) => {
  const slide2 = pptx.addSlide();
  slide2.background = { color: '#c7effc' };
  slide2.addImage({
    path: plantImg,
    x: 8,
    y: 2.5,
    w: 2,
    h: 3,
  });
  slide2.addImage({
    path: womanImg,
    x: 1,
    y: 0.5,
    w: 1.1,
    h: 5,
  });

  slide2.addText(
    [
      {
        text: schoolName,
        options: {
          fontSize: 42,
          color: '696969',
          breakLine: true,
          bold: true,
        },
      },
    ],
    {
      x: 1.5,
      y: 1.8,
      align: 'center',
    },
  );
  slide2.addText(
    [
      {
        text: 'PROGRAMME ET',
        options: {
          fontSize: 42,
          color: '696969',
          breakLine: true,
          bold: true,
        },
      },
      {
        text: 'EVALUATIONS',
        options: {
          fontSize: 42,
          color: '696969',
          breakLine: true,
          bold: true,
        },
      },
    ],
    {
      x: 1.5,
      y: 3.5,
      align: 'center',
    },
  );
};

export default addSlide2;
